export const isValidPolygonGeom = (geom) => {
  if (!geom) return false;
  const isNum = (n) => typeof n === 'number' && Number.isFinite(n);
  const isPos = (c) => Array.isArray(c) && c.length >= 2 && isNum(c[0]) && isNum(c[1]);
  const isRing = (ring) => Array.isArray(ring) && ring.length >= 4 && ring.every(isPos);
  if (geom.type === 'Polygon') {
    return Array.isArray(geom.coordinates) && geom.coordinates.length > 0 && isRing(geom.coordinates[0]);
  }
  if (geom.type === 'MultiPolygon') {
    return Array.isArray(geom.coordinates) && geom.coordinates.some(poly => Array.isArray(poly) && poly.length > 0 && isRing(poly[0]));
  }
  return false;
};

export function removeFirePolygons(map) {
  ['fire-polygons-outline', 'fire-polygons-fill'].forEach(id => {
    if (map.getLayer(id)) map.removeLayer(id);
  });
  if (map.getSource('fire-polygons-src')) map.removeSource('fire-polygons-src');
}